import type { MonospaceUser } from '#layers/data-model/public';
import { defineRelations, withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';
import { SystemWorkspaceMember } from './service-account';
import { UserOrgRole } from './user-org-role';

export const User = withItemType<MonospaceUser>().defineCollection({
	name: 'MonospaceUser',
	scopeId: MONOSPACE_SCOPE_ID,
	meta: {
		defaultFields: [
			'id',
			'email',
			'fullName',
			'isService',
			'avatarId',
			'appearance',
			'status',
		],
		endpoint: 'system/users',
	},
});

export const UserRelations = defineRelations(User, ({ collection }) => ({
	orgRole: {
		to: collection(UserOrgRole, {
			on: {
				'MonospaceUserOrgRole.userId': 'MonospaceUser.id',
			},
		}),
	},
	workspaces: {
		to: collection(SystemWorkspaceMember, {
			on: {
				'MonospaceWorkspaceMember.userId': 'MonospaceUser.id',
			},
		}),
		many: true,
	},
}));
